import React, { useEffect, useState } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 47
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex items-center justify-center gap-2 text-3xl md:text-5xl font-bold font-mono text-brand-cta" data-id="element-248">
      <div className="bg-white px-4 py-3 rounded-lg border border-neutral-200 w-20 md:w-28 text-center shadow-sm" data-id="element-249">
        {String(timeLeft.hours).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-brand-subtitle font-heading mt-1 uppercase tracking-wider" data-id="element-250">
          horas
        </span>
      </div>
      <span className="text-brand-subtitle pb-6" data-id="element-251">:</span>
      <div className="bg-white px-4 py-3 rounded-lg border border-neutral-200 w-20 md:w-28 text-center shadow-sm" data-id="element-252">
        {String(timeLeft.minutes).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-brand-subtitle font-heading mt-1 uppercase tracking-wider" data-id="element-253">
          min
        </span>
      </div>
      <span className="text-brand-subtitle pb-6" data-id="element-254">:</span>
      <div className="bg-white px-4 py-3 rounded-lg border border-neutral-200 w-20 md:w-28 text-center shadow-sm" data-id="element-255">
        {String(timeLeft.seconds).padStart(2, '0')}
        <span className="text-xs md:text-sm block text-brand-subtitle font-heading mt-1 uppercase tracking-wider" data-id="element-256">
          seg
        </span>
      </div>
    </div>;
}